<template>
  <div class="footer">
    <div class="configurator-footer">
      <div class="knowledge-link">
        <a
          target="_blank"
          href="https://passoni.com/knowledge-hub"
          class="uppercase xs-text"
          >knowledge hub</a
        >
      </div>
      <div class="price-wrapper">
        <h3>{{ formatPrice() }}<a href="">*</a></h3>
      </div>
      <div class="preconfigured-link">
        <a class="uppercase xs-text" style="cursor: pointer" @click="$emit('goto-preconfigured')">Change to pre-configured version</a>
      </div>
    </div>
    <div class="asterisc" id="asterisc">
      * All prices displayed on our website are meant for direct clients of Passoni Titanio Societa Benefit s.r.l., with VAT included at the Italian rate. We operate a point of sale at our Atelier in Vimercate (Milano). Shipping costs and any applicable local duties will be calculated with our clients for each project, depending on delivery method and timing.
    </div>
  </div>
</template>

<script>
export default {
  name: "configurator-footer",
  data() {
    return {};
  },
  props: ["price"],
  methods: {
    formatPrice: function () {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",

        // These options are needed to round to whole numbers if that's what you want.
        minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });
      return formatter.format(this.price);
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-footer {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid black;
  height: 80px;
  align-items: center;
  @media (max-width: 767px) {
    margin-top: 50px;
    flex-direction: column;
    height: initial;
  }
  > div:nth-child(1) {
    width: 33%;
  }
  > div:nth-child(2) {
    width: 34%;
    h3 {
      margin-bottom: 0;
    }
  }
  > div:nth-child(3) {
    width: 33%;
  }
  .price-wrapper {
    text-align: center;
  }
}
.knowledge-link  {
  @media (max-width: 767px) {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
.preconfigured-link {
  text-align: right;
  @media (max-width: 767px) {
    text-align: center;
    display: block;
    margin-bottom: 30px;
  }
  a {
    @media (max-width: 767px) {
      display: block;
      line-height: 15px;
    }
  }
}
.asterisc {
  line-height: 15px;
  font-size: 10px;
  text-align: center;
  max-width: 610px;
  margin: 0 auto;
  padding-bottom: 20px;
}
</style>

